import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React from 'react';
import { PropTypes, describe } from 'react-desc';
import { aggregatedClasses } from '@elliemae/ds-classnames';
import DSButton, { buttonTypes } from '@elliemae/ds-button';
import { defaultProps } from './defaultProps.js';

/* eslint-disable max-lines */
const dsBasicSizes = ['s', 'm', 'l'];

const orientation = ['horizontal', 'vertical'];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var blockName = 'button-group';
var GroupContainer = aggregatedClasses('div')(blockName, null, function (_ref) {
  var vertical = _ref.vertical,
      horizontal = _ref.horizontal,
      spacing = _ref.spacing;
  return _defineProperty({
    vertical: vertical,
    horizontal: horizontal
  }, spacing, spacing);
});

var DSButtonGroup = function DSButtonGroup(_ref3) {
  var size = _ref3.size,
      buttonType = _ref3.buttonType,
      orientation = _ref3.orientation,
      spacing = _ref3.spacing,
      buttons = _ref3.children,
      containerProps = _ref3.containerProps;
  return /*#__PURE__*/React.createElement(GroupContainer, _extends({
    classProps: {
      vertical: orientation === 'vertical',
      horizontal: orientation !== 'vertical',
      spacing: spacing
    }
  }, containerProps), React.Children.map(buttons, function (button) {
    return /*#__PURE__*/React.cloneElement(button, _objectSpread({
      buttonType: buttonType,
      size: size
    }, button.props));
  }, null));
};

DSButtonGroup.defaultProps = {
  size: 'm',
  buttonType: 'secondary',
  orientation: 'horizontal'
};
var props = {
  /** props injected to wrapper of page header */
  containerProps: PropTypes.shape({}).description('props injected to wrapper of page header'),

  /**
   * ['s', 'm', 'l']
   */
  size: PropTypes.oneOf(dsBasicSizes).description("['s', 'm', 'l']"),

  /**
   * ['primary', 'secondary', 'text', 'link']
   */
  buttonType: PropTypes.oneOf(buttonTypes).description("['primary', 'secondary', 'text', 'link']"),

  /**
   * ['horizontal', 'vertical']
   */
  orientation: PropTypes.oneOf(orientation).description("['horizontal', 'vertical']"),

  /**
   * ['s', 'm', 'l']
   */
  spacing: PropTypes.oneOf(dsBasicSizes).description("['s', 'm', 'l']"),

  /**
   * Button group items to show of type DSButton
   */
  children: PropTypes.arrayOf(DSButton).description('Button group items to show of type DSButton')
};
DSButtonGroup.defaultProps = defaultProps;
DSButtonGroup.propTypes = props;
var DSButtonGroupWithSchema = describe(DSButtonGroup);
DSButtonGroupWithSchema.propTypes = props;

export default DSButtonGroup;
export { DSButtonGroup, DSButtonGroupWithSchema };
//# sourceMappingURL=DSButtonGroup.js.map
